<template>
  <div v-if="!hasFetched">
    <Fetching />
  </div>

  <div v-else-if="hasFetched && !error && !profile.error" class="invite-wrapper">
    <div class="corner-radius-blur"></div>
    <div class="inner-nav" v-if="isSignedIn">
      <RouterLink to="/account" class="inner-link">
        Manage account
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.00879 0.34375C9.17954 0.172995 9.44365 0.151405 9.6377 0.279297L9.71582 0.34375L15.0195 5.64648C15.1132 5.74016 15.1659 5.86753 15.166 6C15.1659 6.13242 15.1131 6.25983 15.0195 6.35352L9.71582 11.6572C9.52051 11.8519 9.20386 11.8523 9.00879 11.6572C8.81401 11.4621 8.8142 11.1454 9.00879 10.9502L13.459 6.5H1.33301L1.23145 6.49023C1.00412 6.4433 0.833141 6.2412 0.833008 6C0.833186 5.7589 1.00423 5.55773 1.23145 5.51074L1.33301 5.5H13.459L9.00879 1.05078L8.94531 0.97168C8.81752 0.777886 8.83863 0.514551 9.00879 0.34375Z" fill="#181B1F"/>
        </svg>
      </RouterLink>
    </div>

    <div class="inner-content" :class="{'invite' : wasInvited && !hasApp}">
      <div class="wrap">
        <div class="profile-image-wrap">
          <div class="profile-image" v-if="getProfileImage">
            <svg v-if="wasInvited || !profileSetup" width="35" height="73" viewBox="0 0 35 73" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.1953 72.1886C27.0093 72.3665 27.7381 71.469 28.0323 70.8408C28.2505 70.3746 28.652 69.0155 27.8904 68.676C22.7561 66.3872 17.8901 63.337 14.0227 58.9862C10.1961 54.6811 7.3201 49.5326 5.78655 44.0104C5.03432 41.3023 4.63733 38.6609 4.62822 35.914C4.62585 35.2286 4.64676 34.5451 4.69098 33.8651C4.73636 33.1678 4.76322 32.9448 4.88395 32.1236C4.98041 31.4672 5.09824 30.8159 5.23703 30.1712C5.30164 29.8705 5.37141 29.5714 5.44519 29.2735C5.48738 29.1033 5.53083 28.9337 5.57609 28.7646C5.58779 28.7204 5.63595 28.5572 5.66345 28.4626C6.04914 27.2078 6.50285 25.9831 7.03627 24.7982C7.08896 24.6811 7.26181 24.3257 7.2885 24.2663C7.41335 24.0202 7.53808 23.774 7.669 23.5313C7.99502 22.9266 8.3404 22.3344 8.70432 21.7555C8.8637 21.502 9.02681 21.2513 9.19318 21.003C9.26392 20.8973 9.4713 20.6021 9.51821 20.532C9.8811 20.0357 10.2538 19.5474 10.6434 19.0743C11.0486 18.5821 11.4685 18.1033 11.9025 17.6385C12.1051 17.4216 12.313 17.2108 12.5187 16.9971C12.5576 16.9566 12.5882 16.9248 12.6143 16.8976C12.7447 16.7724 12.8766 16.6486 13.0095 16.5263C14.0963 15.5253 15.2543 14.6064 16.4751 13.7807C16.5796 13.7101 16.685 13.6409 16.7901 13.5711C16.8393 13.5391 16.87 13.5191 16.8846 13.5092C16.9198 13.4874 16.955 13.4656 16.9902 13.4436C17.3138 13.2478 17.6385 13.0545 17.9684 12.8694C18.5909 12.5203 19.2265 12.1944 19.8747 11.8938C21.4455 11.1647 23.0177 10.5696 24.6315 10.0543C24.4262 10.2649 24.222 10.4759 24.0201 10.6875C21.3257 13.5089 18.9907 16.6395 17.3441 20.2747C17.0444 20.9365 16.9173 22.2298 17.6741 22.752C18.4385 23.2796 19.4464 22.5998 19.8957 22.0358C21.9589 19.4455 23.9099 16.7508 26.1581 14.3296C28.3287 11.992 30.8498 10.0896 33.3961 7.95789C34.1723 7.30805 34.7875 6.29567 34.8601 5.21476C34.9065 4.52585 34.7318 3.39624 33.8355 3.29634C30.4929 2.92444 27.1306 2.25427 23.7931 1.73967C22.1794 1.49085 20.5654 1.24714 18.9511 1.00765C17.2422 0.754158 15.3812 0.341405 13.6906 0.549159C12.7731 0.662067 11.2044 2.99389 12.4666 3.73751C13.9155 4.59102 15.7786 4.83483 17.3565 5.19814C18.7137 5.51079 20.0713 5.81842 21.4295 6.12408C18.5504 7.18706 15.8806 8.83333 13.4966 10.7318C8.76021 14.5039 5.02835 19.5971 2.79502 25.4228C0.586916 31.1826 -0.0164303 37.5872 1.20711 43.9436C2.37496 50.0101 5.26194 55.8959 9.21262 60.721C13.6334 66.1213 19.5851 70.7434 26.1953 72.1886Z" fill="#FFDE00"/>
            </svg>
            <img :src="getProfileImage" :alt="profile.name" />
          </div>
        </div>

        <h1>{{ wasInvited ? 
          `Unlock with ${profile.name}'s invite code.`
          : 
          'Invite friends to Nourish' }}
        </h1>

        <p v-if="!isSignedIn && wasInvited && hasApp">
          <br/>
          Fantastic!
          <br/><br/>
          We're ready to get you set up.
          <br/><br/>
        </p>
        <p v-if="isSignedIn && isNourish2 && wasInvited">Hooray! You're already joined Nourish!</p>
        <div v-else-if="wasInvited" class="invited-stack">
          <!-- <p>Ready for better news? Accept your invite from {{ profile.name }}.</p> -->
          <!-- <div class="reason-stack">
            <div class="reason-item">
              <span>1</span>
              <p>Get the Nourish app.</p>
            </div>

            <div class="reason-item">
              <span>2</span>
              <p>Use {{ profile.name }}'s exclusive invite code.</p>
            </div>

            <div class="reason-item">
              <span>3</span>
              <p>Feel better, informed.</p>
            </div>
          </div> -->
        </div>
        <div v-else>
          <p>As soon as a friend joins Nourish, you'll earn a channel unlock.</p>
          <div class="meta-block">
            <MetaBlock :items="inviteMeta" style="display: none;" /><!-- @jason-->
          </div>
        </div>

        <div class="invite-code" v-if="(!isSignedIn && wasInvited) || (wasInvited && isSignedIn && !isNourish2)">
          <div v-if="wasInvited && !hasApp" class="tab-callout-marker">
            <span>Continue with {{profile.name}}'s invite code.</span>
            <svg width="17" height="48" viewBox="0 0 17 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.99544 39.3715C3.3061 37.3956 2.94037 34.4772 0.0812931 32.4453C0.0812931 33.7307 -0.12194 34.4745 0.114274 35.0428C1.63819 38.7088 3.12477 42.4004 4.89337 45.9545C6.06775 48.3146 7.77517 48.6562 9.58405 46.8554C11.9463 44.5038 14.0699 41.8987 16.0898 39.2513C16.8633 38.2374 17.6219 36.8337 16.2068 35.2086C12.9838 36.631 12.004 40.2113 9.16645 42.3331C9.0691 41.672 8.9422 41.2851 8.96677 40.9077C9.47163 33.1737 8.89692 25.4835 8.14069 17.7892C7.68991 13.2026 7.53802 8.58842 7.18336 3.9918C7.10225 2.94057 6.86739 1.85701 6.45026 0.893604C6.25535 0.443527 5.47442 0.0465431 4.92669 0.00115967C4.56144 -0.0291634 3.89929 0.541996 3.78951 0.952045C3.51718 1.96854 3.31565 3.05786 3.38447 4.09898C3.86529 11.3721 4.44034 18.6391 4.94779 25.9106C5.25787 30.3544 5.50145 34.8026 5.77494 39.2488C5.5151 39.2897 5.25528 39.3306 4.99544 39.3715Z" fill="#FFDE00"/>
            </svg>
          </div>
          <div class="magic-link link-mid invite-code" v-if="wasInvited">{{ profile.screen_name }}</div>
          <!-- <button v-if="wasInvited && !hasApp" @click="downloadApp()">Get the App</button> -->
          <button v-if="wasInvited && !hasApp" @click="startOnboarding()">Get started</button>
          <!-- <button v-if="wasInvited && !hasApp && isDesktop" class="ghost" @click="startOnboarding()">Continue on desktop</button> -->
          <!-- <button v-if="wasInvited && !hasApp" class="ghost" @click="startOnboarding()">&hellip; or continue here &hellip;</button> -->
        </div>

        <!-- <div v-if="wasInvited && !hasApp" class="right-wrap invite-stack">
          <div class="qr">
            <div class="qr-code">
              <NourishQR />
            </div>

            <div class="stores">
              <div class="store" @click="goAppStore('ios')">
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9036 0C12.0316 1.18299 11.5705 2.34874 10.8968 3.20561C10.1938 4.04914 9.06914 4.69434 7.97368 4.61124C7.8303 3.47293 8.38532 2.2625 9.00663 1.52401C9.70895 0.685963 10.9284 0.0439017 11.9036 0ZM15.4895 6.82427C15.3673 6.89846 13.3414 8.12815 13.3636 10.636C13.3898 13.6636 15.9691 14.6655 16 14.6765C15.9845 14.747 15.5961 16.1221 14.6286 17.5168C13.8207 18.7452 12.9744 19.947 11.6299 19.9682C10.9908 19.9832 10.5593 19.7964 10.1096 19.6019C9.64047 19.3989 9.15166 19.1874 8.38699 19.1874C7.57656 19.1874 7.06613 19.4057 6.57393 19.6163C6.14806 19.7984 5.73585 19.9748 5.15478 19.9988C3.87445 20.0466 2.89616 18.688 2.05907 17.4697C0.385473 14.9838 -0.917216 10.4643 0.829487 7.38881C1.67596 5.88047 3.21915 4.90915 4.86879 4.88328C5.59522 4.86817 6.29194 5.15288 6.90271 5.40247C7.36978 5.59334 7.78659 5.76366 8.12798 5.76366C8.42784 5.76366 8.83294 5.60015 9.3051 5.40956C10.0492 5.10922 10.9598 4.74166 11.8875 4.84094C12.5219 4.85976 14.3272 5.09573 15.4919 6.82279L15.4895 6.82427Z" fill="#9A9AA3"/>
                </svg>
                <div class="content">
                  <span>&ldquo;Nourish News&rdquo; on</span>
                  <h4>Apple AppStore</h4>
                </div>
              </div>

              <div class="store" @click="goAppStore('android')">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.308642 0.253662C0.0771605 0.485144 0 0.870946 0 1.33391V18.3864C0 18.8493 0.154321 19.2351 0.385802 19.4666L0.462963 19.5438L10.0309 9.97588V9.82156L0.308642 0.253662Z" fill="#9A9AA3"/>
                  <path opacity="0.8" d="M13.1177 13.2166L9.9541 10.053V9.82154L13.1177 6.65796L13.1948 6.73512L16.9757 8.89561C18.056 9.5129 18.056 10.516 16.9757 11.1333L13.1177 13.2166Z" fill="#9A9AA3"/>
                  <path opacity="0.5" d="M13.1944 13.1394L9.95366 9.89868L0.308594 19.5437C0.694396 19.9295 1.23452 19.9295 1.92896 19.6209L13.1944 13.1394Z" fill="#9A9AA3"/>
                  <path opacity="0.5" d="M13.1944 6.65797L1.92896 0.253646C1.23452 -0.132156 0.694396 -0.0549959 0.308594 0.330807L9.95366 9.89871L13.1944 6.65797Z" fill="#9A9AA3"/>
                </svg>
                <div class="content">
                  <span>&ldquo;Nourish News&rdquo; on</span>
                  <h4>Google PlayStore</h4>
                </div>
              </div>

              <div class="store" @click="startOnboarding()" v-if="!hasApp && isDesktop">
                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 0C2.89688 0 2 0.896875 2 2V10H4V2H16V10H18V2C18 0.896875 17.1031 0 16 0H4ZM0.6 11C0.26875 11 0 11.2688 0 11.6C0 12.925 1.075 14 2.4 14H17.6C18.925 14 20 12.925 20 11.6C20 11.2688 19.7312 11 19.4 11H0.6Z" fill="black"/>
                </svg>
                <div class="content">
                  <h4>Continue on Desktop</h4>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <button v-if="!isSignedIn && wasInvited && hasApp" @click="startOnboarding()">Let's get started.</button>

      <div v-if="!wasInvited && profileSetup" class="invite-stack">
        <div class="tab-callout-marker">
          <span>Share your unique link with a friend</span>
          <svg width="17" height="48" viewBox="0 0 17 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.99544 39.3715C3.3061 37.3956 2.94037 34.4772 0.0812931 32.4453C0.0812931 33.7307 -0.12194 34.4745 0.114274 35.0428C1.63819 38.7088 3.12477 42.4004 4.89337 45.9545C6.06775 48.3146 7.77517 48.6562 9.58405 46.8554C11.9463 44.5038 14.0699 41.8987 16.0898 39.2513C16.8633 38.2374 17.6219 36.8337 16.2068 35.2086C12.9838 36.631 12.004 40.2113 9.16645 42.3331C9.0691 41.672 8.9422 41.2851 8.96677 40.9077C9.47163 33.1737 8.89692 25.4835 8.14069 17.7892C7.68991 13.2026 7.53802 8.58842 7.18336 3.9918C7.10225 2.94057 6.86739 1.85701 6.45026 0.893604C6.25535 0.443527 5.47442 0.0465431 4.92669 0.00115967C4.56144 -0.0291634 3.89929 0.541996 3.78951 0.952045C3.51718 1.96854 3.31565 3.05786 3.38447 4.09898C3.86529 11.3721 4.44034 18.6391 4.94779 25.9106C5.25787 30.3544 5.50145 34.8026 5.77494 39.2488C5.5151 39.2897 5.25528 39.3306 4.99544 39.3715Z" fill="#FFDE00"/>
          </svg>
        </div>
        <div class="magic-link">
          <span>nourish.vip/{{ profile.screen_name }}</span>
          <div class="magic-buttons">
            <button class="ghost" @click="copyLink()">
              <svg width="172" height="196" viewBox="0 0 172 196" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M147.429 128.625H73.7143C70.3357 128.625 67.5714 125.869 67.5714 122.5V24.5C67.5714 21.1312 70.3357 18.375 73.7143 18.375H124.969C126.581 18.375 128.155 19.0258 129.307 20.1742L151.767 42.5687C152.919 43.7172 153.571 45.2867 153.571 46.8945V122.5C153.571 125.869 150.807 128.625 147.429 128.625ZM73.7143 147H147.429C160.981 147 172 136.013 172 122.5V46.8945C172 40.3867 169.428 34.1469 164.821 29.5531L142.322 7.15859C137.715 2.56484 131.496 0 124.969 0H73.7143C60.1616 0 49.1429 10.9867 49.1429 24.5V122.5C49.1429 136.013 60.1616 147 73.7143 147ZM24.5714 49C11.0188 49 0 59.9867 0 73.5V171.5C0 185.013 11.0188 196 24.5714 196H98.2857C111.838 196 122.857 185.013 122.857 171.5V165.375H104.429V171.5C104.429 174.869 101.664 177.625 98.2857 177.625H24.5714C21.1929 177.625 18.4286 174.869 18.4286 171.5V73.5C18.4286 70.1312 21.1929 67.375 24.5714 67.375H30.7143V49H24.5714Z" fill="black"/>
              </svg>
            </button>
            <button class="ghost" @click="share()">
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.1857 6.20633C12.7052 6.20633 13.1231 5.79123 13.1231 5.27525V2.73806L17.8646 7.44777L13.1231 12.1575V9.62029C13.1231 9.10432 12.7052 8.68921 12.1857 8.68921H7.4989C4.91334 8.68921 2.73397 10.4233 2.07782 12.7821C1.94893 12.301 1.87473 11.7656 1.87473 11.1721C1.87473 8.42928 4.11268 6.20633 6.87399 6.20633H12.1857ZM11.2484 10.5514V13.655C11.2484 14.1554 11.553 14.6093 12.0217 14.8033C12.4904 14.9973 13.0254 14.8886 13.3848 14.5356L19.6338 8.32842C20.1221 7.84348 20.1221 7.05594 19.6338 6.571L13.3848 0.363811C13.0254 0.00689694 12.4904 -0.0978495 12.0217 0.0961253C11.553 0.2901 11.2484 0.740122 11.2484 1.24058V4.34417H6.87399C3.07767 4.34417 0 7.40122 0 11.1721C0 14.1981 1.50759 16.068 2.6832 17.0728C2.84333 17.2086 2.99956 17.3288 3.14016 17.4336C3.26515 17.5267 3.38232 17.6043 3.48777 17.6741C3.66353 17.7905 3.81194 17.872 3.90958 17.9263C4.00723 17.9806 4.11658 18 4.22594 18C4.65166 18 4.99536 17.6547 4.99536 17.2357C4.99536 16.9719 4.85476 16.7236 4.67119 16.5336C4.65166 16.5142 4.63604 16.4986 4.61651 16.4792C4.52277 16.39 4.41732 16.2814 4.31577 16.1456C4.24938 16.0564 4.18298 15.9516 4.12049 15.8391C3.91349 15.4628 3.74945 14.9507 3.74945 14.2796C3.74945 12.2234 5.42889 10.5552 7.4989 10.5552H11.2484V10.5514Z" fill="white"/>
              </svg>
            </button>
          </div>
        </div>

        <transition name="slide-fade" mode="out-in">
          <div v-show="hasCopied" class="link-copy">Link copied!</div>
        </transition>
      </div>

      <div v-if="!wasInvited && !profileSetup" class="setup-stack">
        <p>Before you can send invites, you need to finish setting up your profile.</p>
        <svg width="17" height="48" viewBox="0 0 17 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.99544 39.3715C3.3061 37.3956 2.94037 34.4772 0.0812931 32.4453C0.0812931 33.7307 -0.12194 34.4745 0.114274 35.0428C1.63819 38.7088 3.12477 42.4004 4.89337 45.9545C6.06775 48.3146 7.77517 48.6562 9.58405 46.8554C11.9463 44.5038 14.0699 41.8987 16.0898 39.2513C16.8633 38.2374 17.6219 36.8337 16.2068 35.2086C12.9838 36.631 12.004 40.2113 9.16645 42.3331C9.0691 41.672 8.9422 41.2851 8.96677 40.9077C9.47163 33.1737 8.89692 25.4835 8.14069 17.7892C7.68991 13.2026 7.53802 8.58842 7.18336 3.9918C7.10225 2.94057 6.86739 1.85701 6.45026 0.893604C6.25535 0.443527 5.47442 0.0465431 4.92669 0.00115967C4.56144 -0.0291634 3.89929 0.541996 3.78951 0.952045C3.51718 1.96854 3.31565 3.05786 3.38447 4.09898C3.86529 11.3721 4.44034 18.6391 4.94779 25.9106C5.25787 30.3544 5.50145 34.8026 5.77494 39.2488C5.5151 39.2897 5.25528 39.3306 4.99544 39.3715Z" fill="#FFDE00"/>
        </svg>
        <RouterLink to="/n/profile" class="button">Complete profile setup</RouterLink>
      </div>
    </div>
  </div>

  <div v-else class="invite-wrapper">
    <div class="corner-radius-blur"></div>
    <h1>Uh oh, sorry. We couldn't find that profile.</h1>
    <p>Double check the link you we're sent and try again. If you're still having trouble, get in touch.</p>
    <RouterLink to="/contact" class="button">Contact us</RouterLink>
  </div>
</template>

<script>
  import API from 'app/axios';
  import Fetching from '@/components/v5/Fetching.vue';
  import MetaBlock from '@/components/v5/elements/MetaBlock.vue';
  // import NourishQR from '@/components/v5/elements/NourishQR.vue';

  export default {
    data() {
      return {
        hasFetched: false,
        profile: {},
        error: null,
        hasCopied: false,
        inviteMeta: [
          {
            icon: 'meta-book',
            content: `Unlock a channel for<br>every friend who joins`
          },
          {
            icon: 'meta-celebrate',
            content: `Support us trying to<br>make the news better`
          },
        ]
      }
    },

    components: {
      Fetching,
      MetaBlock,
      // NourishQR,
    },

    async mounted () {
      this.hasFetched = false;

      await API.getAccount(localStorage.getItem('token'));

      if (!this.xname && !this.isSignedIn) {
        this.$router.push('/')
      }

      if (!this.xname && this.isSignedIn) {
        this.$router.replace(`/~${this.getAccount.screen_name}/invite`)
      }

      if (this.xname) {
        // switch into dark mode..
        // this.$layoutEngine.goDark();

        API.getThreadsScreenName(this.xname).then((response) => {
          this.profile = response.profile;
          this.$userEngine.setOnboardMemo({
            invited_by: this.xname,
          });
          this.hasFetched = true;
        }).catch((error) => {
          this.error = error;
          this.hasFetched = true;
        });
      }
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },

      isNourish2() {
        return this.$store.getters.isNourish2;
      },

      hasApp() {
        return this.$store.getters.hasApp;
      },

      isDesktop() {
        return this.$layoutEngine.isDesktop;
      },

      getProfileImage() {
        if (!this.profile || !this.profile.avatar || this.profile.avatar === "https://nourished.news") {
          return false;
        }
        return this.profile.avatar;
      },

      routeXname() {
        return this.$route.params.xname;
      },

      xname() {
        return this.$route.params.xname || this.$userEngine.getOnboardMemo()?.invited_by;
      },

      wasInvited() {
        if (this.getAccount.screen_name === this.xname) {
          return false;
        }

        return true;
      },

      profileSetup() {
        return this.$userEngine.getPref('nourish.invites.setup');
      },

      sUrlInviteGo() {
        let sAuthDefault = this.isSignedIn ? '&upgrade=on' : '';
        return `/n/welcome?n=invite&from=${this.profile.screen_name}${sAuthDefault}`;
      },

      sUrlInviteShareable() {
        return `https://nourish.vip/${this.profile.screen_name}`;
      },
    },

    methods: {
      downloadApp() {
        this.EventBus.$emit('track:event', {
          event: 'invite-download',
          props: { mode: `Download app` },
          detail: { detail_char: `Download app` },
        });

        this.EventBus.$emit('layer:new', {
          component: 'download-app',
          hasTabBar: false,
        });
      },

      share() {

        // track
        this.EventBus.$emit('track:event', {
          event: `invite-share`,
          props: { mode: this.profile.screen_name },
          detail: { detail_char: this.profile.screen_name },
        });

        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'url',
              link: this.sUrlInviteShareable,
            }
          });
          return;
        } else {
          this.EventBus.$emit('layer:new', {
            component: 'message',
            hasTabBar: false,
            opts: {
              heading: `Spread the love`,
              message: `Share your unique link and invite a friend to try Nourish!`,
              share: {
                url: this.sUrlInviteShareable,
                message: `${this.profile.name} has invited you to Nourish!`,
              }
            },
          });
        }
      },

      goAppStore(type) {
        if (type === 'ios') {
          window.open('https://nourished.news/ios', '_blank');
        }

        if (type === 'android') {
          window.open('https://nourished.news/android', '_blank');
        }
      },

      startOnboarding() {
        this.EventBus.$emit('track:event', {
          event: 'invite-continue',
          props: {},
        });

        let sUrl = this.sUrlInviteGo; // break the reactivity *before* we sign out!
        
        // to onboard properly, they need to re-auth...
        // if (this.isSignedIn) { 

        //   // remove the token
        //   window.localStorage.removeItem('token');
          
        //   // tell the app 
        //   this.EventBus.$emit("appCallback", {
        //     type: 'deauthCallback',
        //     data: 'logout'
        //   });
          
        //   // clear the store
        //   this.$store.commit('unsetAccount');
          
        // }

        this.$userEngine.setOnboardMemo({
          invited_by: this.profile.screen_name,
        });
        
        this.$router.push(sUrl);
      },

      copyLink() {
        
        // track
        this.EventBus.$emit('track:event', {
          event: `invite-copy`,
          props: { mode: this.profile.screen_name },
          detail: { detail_char: this.profile.screen_name },
        });

        navigator.clipboard.writeText(this.sUrlInviteShareable).then(() => {
          this.hasCopied = true;
          setTimeout(() => {
            this.hasCopied = false;
          }, 3000)
        }).catch((err) => {
          console.error('Failed to copy link: ', err);
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .invite-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem 0;
    text-align: center;
    gap: 1rem;

    .inner-nav {
      display: flex;
      justify-content: flex-end;
      padding: 0 1rem 1.2rem 1rem;
      border-bottom: 1px solid rgba($neutral-400, 0.25);
      width: 100%;
      font-size: 0.9rem;
      z-index: 10;

      .inner-link {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: $neutral-400;
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;

        svg {
          margin-left: 0.5rem;

          path {
            fill: $neutral-400;
          }
        }
      }
    }

    .wrap {
      position: relative;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      text-align: center;
      gap: 1rem;
      margin-top: 2rem;
      height: 100%;
      max-width: 550px;
    }

    .inner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      padding: 1rem 1rem 2.5rem 1rem;
      max-width: 100%;
    }

    .meta-block {
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      margin-top: 1.5rem;
    }

    .invite-code {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin-top: 1rem;
      margin-bottom: 2rem;

      button {
        width: 100%;
        max-width: 400px;
        margin-top: 0.5rem;
        padding: 1.2rem;
      }
    }

    .invited-stack {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;

      .reason-stack {
        display: flex;
        justify-content: center;
        width: 100%;

        .reason-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          padding: 1rem;
          width: 100%;

          span {
            font-size: 1.2rem;
            font-weight: bold;
            color: $yellow-tone-4;


            .darkmode & {
              color: $yellow-tone-3;
            }
          }

          p {
            font-size: 1rem;
            text-wrap: balance;
            line-height: 140%;
            height: 100%;
          }

          &:not(:last-child) {
            border-right: 1px solid rgba($yellow-tone-4, 0.1);

            .darkmode & {
              border-right: 1px solid rgba($yellow-tone-3, 0.1);
            }
          }
        }
      }
    }

    // .inner-content {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    //   justify-content: center;
    //   padding: 2rem 1rem;
    //   max-width: 400px;
    //   margin: auto;
    //   z-index: 10;

    //   &.invite {
    //     max-width: 1000px;
    //     display: grid;
    //     grid-template-columns: 1fr;
    //     grid-gap: 2rem;
        
    //     @media (min-width: 1000px) {
    //       grid-template-columns: 1fr 1fr;
    //       grid-gap: 4rem;
    //     }
    //   }
    // }

    // .left-wrap {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    // }

    // .right-wrap {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    // }

    .profile-image-wrap {
      position: relative;
      z-index: 10;

      .profile-image {
        width: 8rem;
        height: 8rem;
        padding: 0.7rem;
        border-radius: 500px;
        border: 6px solid rgba($neutral-100, 0.07);
        overflow: hidden;
        margin: auto;

        .desktop & {
          padding: 1rem;
          border: 7px solid rgba($neutral-100, 0.07);
          width: 11rem;
          height: 11rem;
        }

        .darkmode & {
          border-color: rgba($neutral-600, 0.1);
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      svg {
        position: absolute;
        bottom: 0;
        left: -40px;
        height: 50px;
        
        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }

        .desktop & {
          height: 67px;
        }
      }
    }

    h1 {
      font-family: 'Brawler';
      font-weight: normal;
      font-size: 38px;
      line-height: 110%;
      text-wrap: balance;

      .callout {
        color: $yellow-tone-4;

        .darkmode & {
          color: $yellow-tone-3;
        }
      }

      .desktop & {
        font-size: 50px;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;

      .desktop & {
        max-width: 400px;
      }
    }

    .setup-stack {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 2rem;
      border-radius: 10px;
      max-width: 400px;
      margin: 0 auto;
      background: rgba($neutral-100, 0.05);

      .darkmode & {
        background: rgba($neutral-600, 0.05);
      }

      svg {
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.1rem;
        margin-bottom: 1rem;
      }
    }

    .magic-link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      padding: 1rem 1.5rem;
      width: 100%;
      margin-bottom: 0.5rem;
      border-radius: 10px;
      text-align: left;
      font-size: 1rem;
      font-weight: bold;
      background: rgba($neutral-100, 0.05);
      max-width: 400px;

      &.link-mid {
        justify-content: center;
        text-align: center;
      }

      &.invite-code {
        font-size: 2em;
        letter-spacing: .1em;
      }

      .darkmode & {
        background: rgba($neutral-600, 0.05);
      }

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(80%);
        display: inline-block;
      }

      .magic-buttons {
        display: flex;
        align-items: center;
        gap: 1rem;

        .ghost {
          border: 0;
          padding: 0.5rem;
          width: unset;

          svg {
            height: 1rem;
            width: 1rem;

            path {
              fill: $neutral-100;

              .darkmode & {
                fill: $neutral-600;
              }
            }
          }
        }
      }
    }

    .invite-stack {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;

      button {
        width: 100%;
      }

      .link-copy {
        padding: 1rem;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        border-radius: 10px;
        background: $yellow-tone-3;
        color: $neutral-100;
        width: 100%;
        margin-top: 0.5rem;
      }

      .qr {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 1rem;
        width: 100%;

        p {
          color: $neutral-400;
          font-size: 0.9rem;
          margin-top: 0.5rem;
          margin-bottom: 1.5rem;
        }

        .qr-code {

          .mobile & {
            display: none;
          }

          width: 12rem;
          height: 12rem;

          svg {
            width: 100%;
            height: 100%;

            path {
              fill: $neutral-100;

              .darkmode & {
                fill: $neutral-600;
              }
            }
          }
        }

        .stores {
          display: flex;
          flex-direction: column;
          max-width: 250px;
          flex-wrap: wrap;
          gap: 1rem;
          width: 100%;
          margin-top: 1.5rem;

          .store {
            display: flex;
            flex: 1;
            align-items: center;
            padding: 0.75rem 1rem;
            border: 1px solid $neutral-400;
            color: $neutral-400;
            font-size: 0.8rem;
            border-radius: 10px;
            width: 100%;
            cursor: pointer;
            transition: background 0.3s ease-in-out;

            &:hover {
              background: rgba($neutral-400, 0.1);
            }

            svg path {
              fill: $neutral-400;
            }

            .content {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              margin-left: 1rem;

              span, h4 {
                white-space: nowrap;
              }

              h4 {
                margin-top: 0;
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }

  .tab-callout-marker {
        
        // @jason
        flex-direction: row;

    position: relative;
    gap: 0.5rem;
    bottom: 0;
    right: 0;
    margin-bottom: 1rem;

    .desktop & {
      bottom: 0;
      right: 0;
    }

    svg {
      margin: 0;
    }

    span {
      max-width: 250px;
      font-size: 1rem;

      .desktop & {
        font-size: 1rem;
      }
    }
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.5s ease;
  }

  .slide-fade-enter {
    opacity: 0;
    transform: translateY(10px);
  }

  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
</style>